export default __webpack_public_path__ + "static/media/arrow-down.63d4a189.svg";